import api from '../api/axios';

export interface Contact {
  id?: number;
  firstName: string;
  lastName?: string;
  phone: string;
  email?: string;
  whatsappNumber?: string;
  company?: string;
  position?: string;
  address?: string;
  city?: string;
  country?: string;
  tags?: string[];
  notes?: string;
  contactGroups?: any[];
  isActive?: boolean;
  source?: 'manual' | 'import' | 'whatsapp' | 'instagram' | 'website' | 'other';
  instagramHandle?: string;
  birthday?: string;
  customFields?: any;
  aiAutoResponse?: boolean;
}

const ContactService = {
  getAll: (params?: any) => api.get('/contacts', { params }),
  getOne: (id: number) => api.get(`/contacts/${id}`, { params: { populate: '*' } }),
  create: (data: Contact) => api.post('/contacts', { data }),
  update: (id: number, data: Partial<Contact>) => api.put(`/contacts/${id}`, { data }),
  delete: (id: number) => api.delete(`/contacts/${id}`),
  
  // Import contacts
  importContacts: (contacts: Contact[]) => 
    api.post('/contacts/bulk', { contacts }),
};

export default ContactService;

